import { render, staticRenderFns } from "./AppCenter.vue?vue&type=template&id=73ec73bf"
import script from "./AppCenter.vue?vue&type=script&lang=js"
export * from "./AppCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports